// extracted by mini-css-extract-plugin
export default {"ImageGalleryItem":"ImageGalleryItem_ImageGalleryItem__FDGiG","ImageGalleryItem_image":"ImageGalleryItem_ImageGalleryItem_image__GYahN"};